import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Spin, Modal, Button, message } from 'antd';
import { List } from 'immutable';
import {
  RegisterContactsTable,
  RegisterActions,
  TableActions,
} from '../../components';
import {
  hideRegisterContactModal,
  showRegisterContactModal,
} from '../../actions/actionCreators/modalsActionCreators';
import {
  fetchLegalEntityContacts,
  deleteLegalEntityContact,
} from '../../actions/actionCreators/registerContactsActionCreators';
import * as selectors from '../../reducers/registerContactsReducer';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { modalNames } from '../../constants/ModalsActionTypes';
import {
  formRegisterGeneralFields,
  formRegisterContactFields,
} from '../../constants/formRegister';
import { getModalState } from '../../reducers/modalsReducer';
import { getLegalEntityContacts } from '../../schemas';
import { RegisterContact, RegisterLegalEntityContact } from '../../forms';
import './registerContacts.css';

export class RegisterContacts extends Component {
  static propTypes = {
    isContactsLoading: PropTypes.bool.isRequired,
    isContactsDeleteLoading: PropTypes.bool.isRequired,
    contactModalVisible: PropTypes.bool.isRequired,
    contacts: PropTypesImmutable.list,
    fetchLegalEntityContacts: PropTypes.func.isRequired,
    deleteLegalEntityContact: PropTypes.func.isRequired,
    showContactModal: PropTypes.func.isRequired,
    hideContactModal: PropTypes.func.isRequired,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,
    onSubmitSuccess: PropTypes.func,
    legalEntity: PropTypes.object.isRequired,
    isEditMode: PropTypes.bool,
    isAdmin: PropTypes.bool,
    t: PropTypes.func.isRequired,
    showRequestChangeModal: PropTypes.func,
  };

  static defaultProps = {
    contacts: List(),
  };

  state = { editData: null };

  legalEntityFormRef = React.createRef();

  handleAddContact = () => {
    const { legalEntity, showContactModal } = this.props;
    this.setState({
      editData: {
        legalEntityId: legalEntity.get(formRegisterGeneralFields.ID),
        [formRegisterContactFields.PHONE_CODE]: '+372',
      },
    });
    showContactModal();
  };

  handleEditContact = (values) => {
    this.setState({ editData: values.toJS ? values.toJS() : values });
    this.props.showContactModal();
  };

  handleHideContactModal = () => {
    this.setState({ editData: null });
    this.props.hideContactModal();
  };

  componentDidMount = () => {
    const { fetchLegalEntityContacts, legalEntity } = this.props;

    fetchLegalEntityContacts(legalEntity.get(formRegisterGeneralFields.ID));
  };

  goNext = () => {
    const { contacts, t } = this.props;

    if (contacts.isEmpty()) {
      message.error(t('contacts.emptyError'));
    } else {
      this.legalEntityFormRef.current?.submit();
    }
  };

  render() {
    const {
      t,
      isContactsLoading,
      isContactsDeleteLoading,
      contactModalVisible,
      contacts,
      deleteLegalEntityContact,
      hasPrevious,
      hasDone,
      goPrevious,
      legalEntity,
      isEditMode,
      onSubmitSuccess,
      isAdmin,
      showRequestChangeModal,
    } = this.props;

    const inEditForNotAdmin = isEditMode && !isAdmin;

    return (
      <div className="register-contacts">
        <Spin spinning={isContactsLoading}>
          <h2>
            {inEditForNotAdmin ? t('contacts.titleView') : t('contacts.title')}
          </h2>
          <RegisterLegalEntityContact
            onSubmitSuccess={onSubmitSuccess}
            t={t}
            legalEntity={legalEntity}
            inEditForNotAdmin={inEditForNotAdmin}
            formApiRef={this.legalEntityFormRef}
          />
          <Spin spinning={isContactsDeleteLoading}>
            <RegisterContactsTable
              t={t}
              data={contacts.toJS()}
              onDeleteContact={deleteLegalEntityContact}
              onEditContact={this.handleEditContact}
              inEditForNotAdmin={inEditForNotAdmin}
            />
            {!inEditForNotAdmin && (
              <TableActions>
                <Button
                  onClick={this.handleAddContact}
                  size="large"
                  type="primary"
                >
                  {t('contacts.addContact')}
                </Button>
              </TableActions>
            )}
          </Spin>
          <Modal
            onCancel={this.handleHideContactModal}
            open={contactModalVisible}
            footer={false}
            title={t('contacts.contactModalTitle')}
            width="80%"
            destroyOnClose
          >
            <RegisterContact
              t={t}
              initialValues={this.state.editData}
              closeModal={this.handleHideContactModal}
            />
          </Modal>
          <RegisterActions
            hasPrevious={hasPrevious}
            hasDone={hasDone}
            goPrevious={goPrevious}
            goNext={this.goNext}
            isEditMode={isEditMode}
            isAdmin={isAdmin}
            showSaveButton={!inEditForNotAdmin}
            showRequestChangeModal={showRequestChangeModal}
            t={t}
          />
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const contactModalVisible = getModalState(state, modalNames.REGISTER_CONTACT);
  const contactIds = selectors.getEntityContactsList(state);

  const isContactsLoading = getLoadingSelector(selectors.getEntityContactsList)(
    state
  );
  const isContactsDeleteLoading = getLoadingSelector(
    selectors.getEntityContactsDeleteState
  )(state);
  const contacts = getLegalEntityContacts(state, contactIds);

  return {
    contactModalVisible,
    isContactsDeleteLoading,
    isContactsLoading,
    contacts,
  };
};

const mapDispatchToProps = {
  fetchLegalEntityContacts,
  deleteLegalEntityContact,
  showContactModal: showRegisterContactModal,
  hideContactModal: hideRegisterContactModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContacts);
